// DeleteAccount.container: student withdrawal UI; non-social accounts must confirm password before DELETE /my-info/student.
// Mistake: wrong password navigated home and any HTTP 200 was treated as success; require API SUCCESS payload and match agency (alert, stay on page).
// Mistake: INCORRECT_PASSWORD showed a second alert (errPasswordMatch) after Auth.api errorHandler already surfaced the API message—omit the duplicate.
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import DeleteAccountComponent from "./DeleteAccount.component";
import { getLanguageValue } from "locales/i18n";
import { PAGE_TYPE } from "enums";

import * as AuthApi from "api/common/Auth.api";

const isStudentWithdrawalSucceeded = (result: any) =>
    result &&
    result.status === 200 &&
    !result.errorCode &&
    result.data?.messageCode === "SUCCESS" &&
    result.data?.data?.result === true;

const DeleteAccountContainer = (props: any) => {
    const { info: myInfo } = useSelector((state: any) => state.user);
    const isSocialSignup = myInfo?.signupTypeCode === "signupType:socialAccount";

    const navigate = useNavigate();

    const [withdrawalReasonCode, setWithdrawalReasonCode] = useState("");
    const [withdrawalOtherReason, setWithdrawalOtherReason] = useState("");
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [password, setPassword] = useState("");

    const deleteAccount = async () => {
        if (!window.confirm(getLanguageValue(PAGE_TYPE.COMMON, "deleteAccount.txtConfirm"))) {
            return;
        }

        if (!isSocialSignup && !password.trim()) {
            alert(getLanguageValue(PAGE_TYPE.COMMON, "deleteAccount.txtPasswordPlaceholder"));
            return;
        }

        setIsButtonDisabled(true);

        try {
            const result = await AuthApi.deleteStudentAccount(password, withdrawalReasonCode, withdrawalOtherReason);

            if (isStudentWithdrawalSucceeded(result)) {
                navigate("/logout");
                return;
            }
            // Wrong password and other 400s: errorHandler already alerted with API message.
        } catch (error) {
            console.error("Failed to delete account:", error);
            alert("Failed to delete account, try again later.");
        } finally {
            setIsButtonDisabled(false);
        }
    };

    return (
        <DeleteAccountComponent
            onClickBtnDeleteAccount={deleteAccount}
            setWithdrawalReasonCode={setWithdrawalReasonCode}
            setWithdrawalOtherReason={setWithdrawalOtherReason}
            withdrawalReasonCode={withdrawalReasonCode}
            isButtonDisabled={isButtonDisabled}
            isSocialSignup={isSocialSignup}
            password={password}
            setPassword={setPassword}
        />
    );
};

export default DeleteAccountContainer;
